import { Distributor } from '../../models/distributor';
import { customerHubHttp } from '../customer-hub-api';

export const getDistributors = async (
  country: string,
  abortController?: AbortController
): Promise<Distributor[]> => {
  try {
    const url = `/jabra-locator/distributors?country=${encodeURIComponent(country)}`;
    const response = await customerHubHttp.get<Distributor[]>(url, {
      signal: abortController?.signal,
    });

    return response?.data ?? [];
  } catch (error) {
    console.error(`Error fetching distributors:`, error);
    return [];
  }
};
